export default "__VITE_ASSET__CTZh0NJa__"